<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Supplier Invoices Management
                      </h4>
                  </div><!--col-->
              </div><!--row-->
              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="supplier_id" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.supplier_name') }}</label>
                        <div class="col-sm-4" v-bind:class="{'form-group--error': $v.supplierInvoice.supplier_id.$error }">
                          <select v-model="supplierInvoice.supplier_id" class="form-control" required>
                            <option value="">-- {{ $t('general.input.please_select_supplier') }} --</option>
                            <option v-for="(supplier, index) in suppliers" :value="supplier.id" :key="index">{{ supplier.primary_name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="invoice_no" class="col-sm-2 col-form-label form__label">{{ $t('supplier.invoice.label.invoice_no') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.supplierInvoice.invoice_no.$error }">
                          <input v-model.trim="supplierInvoice.invoice_no" @input="$v.supplierInvoice.invoice_no.$touch()" type="text" name="invoice_no" class="form-control form__label">
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="description" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.description') }}</label>
                        <div class="col-sm-6">
                          <input v-model.trim="supplierInvoice.description" type="text" name="description" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="date" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.date') }}</label>
                        <div class="col-sm-3">
                          <input v-model.trim="supplierInvoice.date" type="date" name="date" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="due_date" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.due_date') }}</label>
                        <div class="col-sm-3">
                          <input v-model.trim="supplierInvoice.due_date" type="date" name="due_date" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="total_amount" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.total_amount') }}</label>
                        <div class="col-sm-3">
                          <input v-model.trim="supplierInvoice.total_amount" type="number" name="total_amount" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('supplier.invoice.label.remark') }}</label>
                        <div class="col-sm-6">
                          <textarea v-model.trim="supplierInvoice.remark" rows="4" name="remark" class="form-control" />
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->
              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'SupplierInvoiceCreate',
  components: {
    loadingPanel
  },
  beforeCreate () {
    this.axios.get('supplier-invoice/create').then(response => {
      if (response.data) {
        if (response.data.suppliers && response.data.suppliers.length > 0) {
          this.suppliers = response.data.suppliers
        } else {
          this.$swal({
            title: 'You have not set your supplier',
            text: 'Please Create Supplier First!',
            icon: 'warning'
          }).then(() => {
            this.$router.push('/supplier/create')
          })
        }
      }
    }).catch(error => {
      console.log(error)
    })
  },
  mounted () {
  },
  data () {
    return {
      suppliers: [],
      supplierInvoice: {
        supplier_id: '',
        invoice_no: '',
        description: '',
        date: '',
        due_date: '',
        total_amount: '',
        remark: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      this.$v.supplierInvoice.$touch()
      if (this.$v.supplierInvoice.$error) {
        this.$swal({
          title: 'You have not set your supplier primary name',
          icon: 'warning',
          animation: false,
          customClass: 'animated tada'
        })
        return
      }
      // create supplier
      this.showLoadingPanel = true
      this.axios.post('/supplier-invoice', this.supplierInvoice).then(() => {
        this.showLoadingPanel = false
        this.$router.push('/supplier-invoice')
      }).catch(error => {
        this.showLoadingPanel = false
        this.showAlert('danger', error.data.message)
      })
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  },
  validations: {
    supplierInvoice: {
      supplier_id: {
        required
      },
      invoice_no: {
        required
      }
    }
  }
}
</script>
